module.exports = __webpack_public_path__ + "img/Support-skill-415.932110d3.png";